import { printError } from '@/lib/log'
import { basePath, callAPI } from '../common'

export type TagInBenchmark = {
  name: string
  slug: string
}

export type DomesticBenchmarksData = {
  shortname: string
  name: string
  description: string | null
  tags: TagInBenchmark[] | null
  established: string | null
  lastFundraised: string | null
  latestInitialSeries: string | null
  totalFunding: number | null
  valuation: number | null
  imageUrl: string | null
  isPublic: boolean
}

export type DomesticBenchmarkResponseType = {
  domesticBenchmarkCompanies: DomesticBenchmarksData[]
}

export const fetchDomesticBenchmarkCompanies = async (shortname: string) => {
  try {
    return await callAPI<DomesticBenchmarkResponseType>(
      `${basePath}/v1/companies/${shortname}/domestic_benchmarks`,
      {
        credentials: 'include',
      }
    )
  } catch (e) {
    printError(e)
    return { domesticBenchmarkCompanies: [] }
  }
}
